export enum COUNTRY_CODE {
  NZ = "NZ"
}
export const DEFAULT_COUNTRY_CODE = COUNTRY_CODE.NZ;

export const COUNTRY_CODE_LOCALES: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: 'en-NZ'
}

export const COUNTRY_CODE_CURRENCIES: Record<COUNTRY_CODE, string> = {
  [COUNTRY_CODE.NZ]: 'NZD'
}

export const TAX_PERCENTAGES: Record<COUNTRY_CODE, number> = {
  [COUNTRY_CODE.NZ]: 0.15
}